const MyExamineComponent = () => import('@/views/user/MyExamineView')

export default [
    {
        path:'/MyExamine',
        name:'MyExamineComponent',
        component:MyExamineComponent
    }
]